import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "b-form-recurrence" }
const _hoisted_2 = { class: "h-text-center h-mv-20" }
const _hoisted_3 = { class: "b-base-title h-mb-30" }
const _hoisted_4 = {
  key: 0,
  class: "h-font-14"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "h-width-100p h-flex h-flex-space-between h-mv-10" }
const _hoisted_8 = {
  key: 0,
  class: "b-form-recurrence__select"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturesSaveButton = _resolveComponent("FeaturesSaveButton")!
  const _component_FwCheckbox = _resolveComponent("FwCheckbox")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwSelect = _resolveComponent("FwSelect")!
  const _component_FormMenuItem = _resolveComponent("FormMenuItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isSaveButtonShow)
      ? (_openBlock(), _createBlock(_component_FeaturesSaveButton, {
          key: 0,
          onClick: _ctx.setRecurrenceHandler
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('EVENT.NAME.LOCATION.RECURRENCE')), 1),
        (_ctx.recurrenceDescription)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t(_ctx.recurrenceDescription)
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurrenceList, (item, index) => {
          return (_openBlock(), _createBlock(_component_FormMenuItem, {
            key: index,
            class: "h-mv-10",
            title: _ctx.$t(item.title),
            isActive: index === _ctx.activeIndex,
            leftIcon: "reccurance-icon",
            onClick: ($event: any) => (_ctx.updateMenu(index))
          }, {
            default: _withCtx(() => [
              (_ctx.isRecurrenceOptionsActive && _ctx.activeIndex === item.id && !_ctx.isEveryYearStateActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurrenceCheckBoxDay, (day, id) => {
                          return (_openBlock(), _createBlock(_component_FwCheckbox, {
                            id: day.id,
                            key: id,
                            modelValue: _ctx.localDayList,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDayList) = $event)),
                            value: day.value,
                            singleSelect: _ctx.isEveryMonthStateActive,
                            type: "form-light",
                            text: day.text,
                            name: "checkbox",
                            onChange: _ctx.change
                          }, null, 8, ["id", "modelValue", "value", "singleSelect", "text", "onChange"]))
                        }), 128))
                      ])
                    ]),
                    (_ctx.isEveryMonthStateActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: "h-pos-rel b-calendar-select__week fw-select-base fw-select-base__time",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_component_FwIcon, {
                              class: "b-form-recurrence__icon",
                              icon: "calendar",
                              color: "#BEC7D4",
                              size: "18"
                            }),
                            _createVNode(_component_FwSelect, {
                              modelValue: _ctx.weekIndexLocal,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.weekIndexLocal) = $event)),
                              class: _normalizeClass({ "b-recurrence--not-active": _ctx.weekIndexLocal.value === null }),
                              searchable: false,
                              canNotDelete: true,
                              label: "text",
                              options: _ctx.weekIndexOptions
                            }, null, 8, ["modelValue", "class", "options"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title", "isActive", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}